import { render } from "./StandardWebsites.vue?vue&type=template&id=1c9f88a0"
import script from "./StandardWebsites.vue?vue&type=script&lang=js"
export * from "./StandardWebsites.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__